import CirgsReportDetails from './CirgsReportDetails';

export default CirgsReportDetails;
